import { axiosClient } from '../../clients/axios-client'
import type { Prompt, PromptLanguage } from '../../types'
import type { GetPromptsResponseDto } from './dtos/prompt'
import { GetPromptsResponseDtoSchema } from './dtos/prompt'
import { mapPrompt } from './prompt-mapper'

export interface PromptsResult {
  favorites: Prompt[]
  standard: Prompt[]
  custom: Prompt[]
}

export async function getPrompts(lang: PromptLanguage): Promise<PromptsResult> {
  try {
    const { data } = await axiosClient.get<GetPromptsResponseDto>('/prompts', {
      params: { lang },
    })
    const parsed = GetPromptsResponseDtoSchema.parse(data)

    return {
      favorites: parsed.favorites.map(mapPrompt),
      standard: parsed.standard.map(mapPrompt),
      custom: parsed.custom.map(mapPrompt),
    }
  } catch (error) {
    console.error('Error getting prompts', error)
    throw error
  }
}
